<template>
  <div>
    <el-collapse v-model="activeNames" class="customer-container">
      <el-collapse-item title="基本信息" name="1">
        <template #title>
          <h3>申请人</h3>
        </template>
        <el-empty v-if="!orderCustomer" description="暂无数据"/>
        <div v-else class="order-info">
          <div class="info-item">名称: {{ orderCustomer.name }}</div>
          <div class="info-item">手机号: {{ orderCustomer.mobile }}</div>
          <div class="info-item">身份证: {{ orderCustomer.idcard }}</div>
          <div class="info-item">户籍地址: {{ orderCustomer.idcardArea + orderCustomer.idcardAddress }}</div>
          <div class="info-item">身份证有效期: {{ orderCustomer.idcardValidityDate }}</div>
          <div class="info-item">居住地址: {{ orderCustomer.resideArea + orderCustomer.resideAddress }}</div>
          <div class="info-item">婚姻状况: {{ $dict.nameOf('order_marital_status', orderCustomer.maritalStatus) }}</div>
          <div class="info-item">有无驾照: {{
              $dict.nameOf('driving_license_status', orderCustomer.drivingLicenseStatus)
            }}
          </div>
          <div class="info-item">居住状况: {{
              $dict.nameOf('order_reside_condition', orderCustomer.resideCondition)
            }}
          </div>
          <div class="info-item">居住年限/年: {{ orderCustomer.resideDate }}</div>
          <div class="info-item">学历: {{ $dict.nameOf('order_education_bg', orderCustomer.educationBg) }}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template #title>
          <h3>工作信息</h3>
        </template>
        <el-empty v-if="!orderWork" description="暂无数据"/>
        <div class="order-info" v-else>
          <div class="info-item">就业状态: {{ $dict.nameOf('order_job_status', orderWork.status) }}</div>
          <div class="info-item">所属行业: {{ $dict.nameOf('order_industry', orderWork.industry) }}</div>
          <div class="info-item">单位性质: {{ $dict.nameOf('order_mode', orderWork.mode) }}</div>
          <div class="info-item">工作职务: {{ $dict.nameOf('order_position', orderWork.position) }}</div>
          <div class="info-item">工作职称: {{
              $dict.nameOf('order_positional_titles', orderWork.positionalTitles)
            }}
          </div>
          <div class="info-item">工作固定/收手机: {{ orderWork.jobPhone }}</div>
          <div class="info-item">公司名称: {{ orderWork.company }}</div>
          <div class="info-item">单位地址: {{ orderWork.companyArea + orderWork.companyAddress }}</div>
          <div class="info-item">参加工作时间: {{ orderWork.firstJobTime }}</div>
          <div class="info-item">现单位工作年限: {{ orderWork.joinCompanyTime }}</div>
          <div class="info-item">税后月收入: {{ orderWork.salary }}</div>
          <div v-if="orderWork.brandType === '0'" class="info-item">是否公牌: {{
              String(orderWork.brandType) === '1' ? '一般工牌' : '非工牌'
            }}
          </div>
          <div v-if="orderWork.brandType === '1'">
            <el-divider/>
            <div class="info-item">是否公牌: {{ String(orderWork.brandType) === '1' ? '一般工牌' : '非工牌' }}</div>
            <div class="info-item">公牌法人: {{ orderWork.legalPerson }}</div>
            <div class="info-item">公牌法人身份证: {{ orderWork.legalPersonCard }}</div>
            <div class="info-item">企业名称: {{ orderWork.enterpriseName }}</div>
            <div class="info-item">统一社会信用代码: {{ orderWork.enterpriseCode }}</div>
            <div class="info-item">注册地址: {{ orderWork.enterpriseArea + orderWork.enterpriseAddress }}</div>
            <div class="info-item">注册日期: {{ orderWork.enterpriseDate }}</div>
            <div class="info-item">注册电话: {{ orderWork.enterprisePhone }}</div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template #title>
          <h3>银行卡</h3>
        </template>
        <el-empty v-if="!orderBank" description="暂无数据"/>
        <div class="order-info" v-else>
          <div class="info-item">银行名称: {{ orderBank.bankName }}</div>
          <div class="info-item">银行卡号: {{ orderBank.bankNo }}</div>
          <div class="info-item">开户行: {{ orderBank.bankAddress }}</div>
          <div class="info-item">银行卡类型: {{ $dict.nameOf('order_bank_type', orderBank.bankType) }}</div>
          <div class="info-item">持卡人姓名: {{ orderBank.bankUser }}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template #title>
          <h3>联系人</h3>
        </template>
        <el-empty v-if="!orderContactList || orderContactList.length === 0" description="暂无数据"/>
        <div class="order-info" v-else>
          <div class="info-item" v-for="(contact, index) in orderContactList" :key="index">
            <div>联系人{{ index + 1 }}:</div>
            <div>关系: {{ $dict.nameOf('order_contact_relation', contact.relation) }}</div>
            <div>名称: {{ contact.name }}</div>
            <div>联系电话: {{ contact.mobile }}</div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template #title>
          <h3>担保状况</h3>
        </template>
        <el-empty v-if="!orderGuarantee" description="暂无数据"/>
        <div class="order-info" v-else>
          <div class="info-item">婚姻状况: {{ $dict.nameOf('order_marital_status', orderGuarantee.maritalStatus) }}</div>
          <div class="info-item">配偶姓名: {{ orderGuarantee.spouseName }}</div>
          <div class="info-item">配偶手机: {{ orderGuarantee.spouseMobile }}</div>
          <div class="info-item">配偶身份证: {{ orderGuarantee.spouseIdcard }}</div>
          <div class="info-item">配偶工作单位: {{ orderGuarantee.spouseCompany }}</div>
          <div class="info-item"></div>
          <div class="info-item">担保人姓名: {{ orderGuarantee.name }}</div>
          <div class="info-item">手机号: {{ orderGuarantee.mobile }}</div>
          <div class="info-item">身份证: {{ orderGuarantee.idcard }}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template #title>
          <h3>影像资料</h3>
        </template>
        <el-empty v-if="!customerMaterialList || customerMaterialList.length === 0" description="暂无数据"/>
        <order-material v-else :materials="customerMaterialList" :model="1"></order-material>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>

import OrderMaterial from "@/views/order/info/componet/OrderMaterial.vue";

export default {
  name: "OrderCustomer",
  components: {OrderMaterial},
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  mounted() {
  },
  computed: {
    orderCustomer() {
      return this.orderDetail.orderCustomer;
    },
    orderBank() {
      return this.orderDetail.orderBank;
    },
    orderWork() {
      return this.orderDetail.orderWork;
    },
    orderContactList() {
      return this.orderDetail.orderContactList;
    },
    orderGuarantee() {
      return this.orderDetail.orderGuarantee;
    },
    customerMaterialList() {
      return this.orderDetail.customerMaterialList;
    }
  },
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5'],
    };
  },
  methods: {},
}
</script>

<style scoped>
.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>
